import { request } from "@/axios";

// 批量新增团队成员信息
interface AddTeamUserData {
  dtoList: {
    email?: string;
    account?: string;
    nickname: string;
  }[];
}

// 获取团队信息
enum MemberType {
  Pro = "pro",
  Plus = "plus",
  Ultra = "ultra"
}

enum UserRole {
  SuperAdmin = 1,
  Member = 2
}

export interface TeamInfo {
  /** 会员有效期开始时间 */
  startTime: string;
  /** 会员有效期结束时间 */
  endTime: string;
  /** 是否过期 */
  expire: boolean;
  /** 团队成员是否被踢出团队*/
  expelTeam: boolean;
  /** 团队成员被踢出团队时间*/
  expelTeamTime: string;
  /** 支持人员数量 */
  headCount: number;
  /** 会员类型：free-免费版 pro-标准版会员 plus-专业版会员 ultra-旗舰版会员 */
  memberType: `${MemberType}`;
  /** 团队名称 */
  name: string;
  /** 当前用户角色：1-超管 2-成员 */
  role: UserRole;
  /** 团队ID */
  teamId: number;
  /** 会员天数 */
  memberDay: number;
  /** 剩余天数 */
  leaveDay: number;
  /** 团队个人已使用空间 */
  personalSpace: number;
  /** 团队共享已使用空间 */
  shareSpace: number;
  /** 团队已使用总空间 */
  totalSpace: number;
  /** 团队总空间 */
  allSpace: number;
  /** 团队总算力 */
  totalPoints: number;
  /** 可用算力 */
  usablePoints: number;

  /**团队续费续费的人数 */
  preparHeadCount: number;

  /** 团队续费类型 1正式版 2试用版 3待定版*/
  periodType: number;
}

// 团队成员信息
export interface TeamUserInfo {
  account: string;
  email: string;
  joinStatus: number;
  nickname: string;
  role: number;
  userId: number;
}
interface QueryTeamUserInfoResponse {
  headCount: number;
  joinCount: number;
  leftCount: number;
  preparHeadCount:number;
  preparLeftCount:number;
  teamUserPage: {
    records: TeamUserInfo[];
    total: number;
  };
}

export function addTeamUserInfoBatch(data: AddTeamUserData) {
  return request({
    api: "/api/team/addTeamUserInfoBatch",
    method: "post",
    data
  });
}

// 修改团队信息
export function editTeamInfo(data: { name: string }) {
  return request({
    api: "/api/team/editTeamInfo",
    method: "post",
    data
  });
}

// 修改团队成员信息
export function editTeamUserInfo(data: { nickname: string; userId: number }) {
  return request({
    api: "/api/team/editTeamUserInfo",
    method: "post",
    data
  });
}

export function queryTeamInfo() {
  return request<TeamInfo>({
    api: "/api/team/teamInfo",
    method: "post"
  });
}

export function queryTeamUserInfo(data: { pageNo: number; pageSize: number }) {
  return request<QueryTeamUserInfoResponse>({
    api: "/api/team/teamUserInfo",
    method: "post",
    data
  });
}

export function changeTeamAdminUser(data: { account: string; code: string; email: string; receivingUserId: number }) {
  return request<QueryTeamUserInfoResponse>({
    api: "/api/team/changeTeamAdminUser",
    method: "post",
    data
  });
}
// 移除团队成员
export function removeTeamUser(data: { receivingUserId?: number; removeType: number; userId: number }) {
  return request({
    api: "/api/team/removeTeamUser",
    method: "post",
    data
  });
}

// 团队用户云空间
export function teamUserSpaceData(data: { userId: number }) {
  return request({
    api: "/api/team/teamUserSpaceData",
    method: "post",
    data
  });
}
